import { useMemo } from 'react';

import useForm from '../utils/useForm';

const useContactForm = (onSubmit, values, isSuperAdmin) => {
  const isEdit = !!values;

  const fields = useMemo(
    () => [
      {
        title: isEdit ? 'Edit Contact' : 'New Contact',
        fields: [
          {
            title: 'First name',
            name: 'first_name',
            type: 'text',
            required: true,
          },
          {
            title: 'Last name',
            name: 'last_name',
            type: 'text',
            required: true,
          },
          {
            title: 'Signer',
            name: 'is_signer',
            type: 'text',
            isHidden: () => !!isSuperAdmin,
            format: (value) => (value ? 'Yes' : 'No'),
          },
          {
            title: 'Signer',
            name: 'is_signer',
            type: 'checkbox',
            isHidden: () => !isSuperAdmin,
          },
        ],
      },
    ],
    [isEdit, isSuperAdmin]
  );

  const { formik } = useForm({ fields, onSubmit, values });

  return { formik, fields, values };
};

export default useContactForm;
